<span class="title" [textContent]="text">text</span>